import { createSoftBreakPlugin as createPlateSoftBreakPlugin, KEY_SOFT_BREAK } from '@udecode/plate-break';
import { ELEMENT_CODE_LINE } from '../../pluginKeys';

export const createSoftBreakPlugin = () => createPlateSoftBreakPlugin({
  key: KEY_SOFT_BREAK,
  options: {
    rules: [
      {
        hotkey: 'shift+enter',
        query: {
          exclude: [ELEMENT_CODE_LINE],
        },
      },
    ],
  },
});
